// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL || (() => {
  // In test environment, use mock values
  if (import.meta.env.MODE === 'test' || import.meta.env.VITEST) {
    return 'https://test-project.supabase.co';
  }
  throw new Error('VITE_SUPABASE_URL environment variable is required');
})();
const SUPABASE_PUBLISHABLE_KEY = import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY || (() => {
  // In test environment, use mock values
  if (import.meta.env.MODE === 'test' || import.meta.env.VITEST) {
    return 'test_publishable_key';
  }
  return "YOUR_PUBLISHABLE_KEY_HERE";
})();

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true, // Properly handle OAuth callbacks
    flowType: 'pkce', // Use PKCE flow for better security
  }
});